import { jsx as _jsx } from "react/jsx-runtime";
import Legal from '~components/legal';
const PrivacyPolicy = () => _jsx(Legal, { id: "privacy-policy" });
export default PrivacyPolicy;
